import { render, staticRenderFns } from "./PresupuestoDetalles.vue?vue&type=template&id=333ece9e&scoped=true"
import script from "./PresupuestoDetalles.vue?vue&type=script&lang=js"
export * from "./PresupuestoDetalles.vue?vue&type=script&lang=js"
import style0 from "./PresupuestoDetalles.vue?vue&type=style&index=0&id=333ece9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333ece9e",
  null
  
)

export default component.exports